/* eslint-disable jsx-a11y/anchor-is-valid */

import { FaInstagram, FaLinkedin } from "react-icons/fa";
import { FiFacebook } from "react-icons/fi";
import { BiEnvelope, BiMapPin, BiPhone } from "react-icons/bi";
import emlakjet from "../assets/emlakjet_white.png";
import { mainContact, siteName } from "../../../data/artemulkContent";
import ArtemulkLogo from "../ArtemulkLogo";

const Footer = () => {
  return (
    <div className="px-[2%] md:px-[6%] bg-card-dark border border-card-dark">
      <div className="mt-10">
        <div className="text-slate-200">
          <footer>
            <div className="flex flex-wrap gap-8">
              <div className="flex-1 basis-[14rem]">
                <div className="flex justify-center items-center h-[80px] sm:h-[100px]">
                  <ArtemulkLogo
                    white
                    whiteInDark={false}
                    className="h-11 w-auto max-w-[240px] sm:h-12"
                  />
                </div>
                <p className="mt-4 text-sm text-muted">
                  Gayrimenkul alanında aracılık, danışmanlık ve portföy yönetim hizmetleri.
                </p>
                <div className="gap-4 my-6 flex flex-wrap">
                  <a
                    href="https://www.facebook.com/profile.php?id=61574915662575"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-box bg-[#c5955b] hover:bg-[#674921]"
                  >
                    <FiFacebook className="text-[#252836] w-[22px]" />
                  </a>
                  <a
                    href="https://www.instagram.com/artemulkyonetimi/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-box bg-[#c5955b] hover:bg-[#674921]"
                  >
                    <FaInstagram className="text-[#252836] w-[22px]" />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/artem%C3%BClk-y%C3%B6netimi-ve-dan%C4%B1%C5%9Fmanl%C4%B1k/posts/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-box bg-[#c5955b] hover:bg-[#674921]"
                  >
                    <FaLinkedin className="text-[#252836] w-[22px]" />
                  </a>
                </div>
              </div>

              <div className="flex-1 basis-[12rem]">
                <h2 className="text-xl font-semibold mb-4">Hızlı Bağlantı</h2>
                <ul className="space-y-2 text-muted">
                  <li><a href="/">Anasayfa</a></li>
                  <li><a href="/subelerimiz">Şubelerimiz</a></li>
                  <li><a href="/about">Hakkımızda</a></li>
                  <li><a href="/adverts">İlanlarımız</a></li>
                  <li><a href="/contact">İletişim</a></li>
                </ul>
              </div>

              <div className="flex-1 basis-[14rem]">
                <h2 className="text-xl font-semibold mb-4">İletişime Geçin</h2>
                <p className="flex items-start gap-2 text-sm text-muted mb-2">
                  <BiMapPin className="shrink-0 text-primary mt-0.5" />
                  Hasanpaşa Mah., Uzunçayır Cad. No: 61, Kadıköy / İstanbul
                </p>
                {mainContact.phone ? (
                  <p className="flex items-center gap-2 text-sm text-muted mb-2">
                    <BiPhone className="shrink-0 text-primary" />
                    <a href={`tel:${mainContact.phone.replace(/\s/g, "")}`}>{mainContact.phone}</a>
                  </p>
                ) : null}
                <p className="flex items-center gap-2 text-sm text-muted">
                  <BiEnvelope className="shrink-0 text-primary" />
                  <a href={`mailto:${mainContact.email}`} className="text-primary normal-case">
                    {mainContact.email}
                  </a>
                </p>
              </div>
            </div>
          </footer>

          <div className="py-4 mt-6 text-center border-t text-muted border-dark">
            <div className="flex justify-between items-center flex-wrap gap-4">
              <a
                href="https://www.emlakjet.com/emlak-ofisleri-detay/arte-mulk-yonetimi-1958181"
                target="_blank"
                rel="noreferrer"
              >
                <img src={emlakjet} alt="Emlakjet" className="w-[120px] h-auto" />
              </a>
              <p className="text-xs sm:text-base flex-1 text-center">
                {siteName} | Emlakjet Entegrasyonu | Tüm Hakları Saklıdır © {new Date().getFullYear()}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
